import { Link } from "react-router-dom";

export default function ReglesCommunaute() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white" data-testid="rules-page">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-[#C9A961] text-xs uppercase tracking-widest font-bold mb-2" data-testid="rules-brand">Institut Impact Élite Martial × Kaizen System — Cercle K'Ien</p>
        <h1 className="text-4xl sm:text-5xl font-black mb-3">Règles & confidentialité</h1>
        <p className="text-white/50 mb-10">Le Cercle K'Ien réunit les membres de l'Institut Impact Élite Martial qui souhaitent, de leur plein gré, trouver des partenaires d'entraînement. Voici comment on garde cet espace sécuritaire et respectueux.</p>

        <Section title="1. Respect avant tout">
          Aucune insulte, harcèlement, propos haineux, ni sollicitation commerciale. On est une <b>gang de personnes qui s'entraident</b>. Tout manquement peut mener à une suspension immédiate.
        </Section>
        <Section title="2. Ta vie privée est protégée (Loi 25)">
          Ton adresse, ton téléphone, ton courriel et ta date de naissance ne sont <b>jamais</b> affichés. Seuls les éléments que tu choisis volontairement sont visibles : pseudonyme/prénom, région générale, province/pays, disciplines, niveau et objectif. Tu peux <b>retirer ton profil</b> et <b>retirer ton consentement</b> en tout temps.
        </Section>
        <Section title="3. Contact 100 % volontaire">
          Personne ne peut t'écrire sans que tu aies <b>accepté sa demande de contact</b>. La messagerie privée s'ouvre uniquement après une acceptation mutuelle. Tu peux <b>bloquer</b> ou <b>signaler</b> un membre à tout moment.
        </Section>
        <Section title="4. Rencontres sécuritaires">
          Les rencontres organisées se tiennent <b>uniquement dans des lieux publics</b> (parc, gym, dojo). Ne partage jamais une adresse privée. Respecte le niveau demandé et les règles de sécurité de chaque rencontre.
        </Section>
        <Section title="5. Consentement libre, clair et retirable">
          Ton adhésion au Cercle est distincte de ton inscription à l'Académie. Conformément à la <b>Loi 25</b> (protection des renseignements personnels au Québec), ton consentement est libre, clair et spécifique, et tu peux le retirer quand tu veux depuis ton espace membre.
        </Section>

        <div className="mt-10 border-t border-white/10 pt-6 text-white/40 text-sm">
          Des questions ? Écris-nous à <a href="mailto:impactkb.bjj@gmail.com" className="text-[#C9A961] hover:underline">impactkb.bjj@gmail.com</a> ou (819) 527-9446.
          <div className="mt-4">
            <Link to="/membres" className="inline-block bg-[#D90429] text-white font-bold px-6 py-3 rounded-lg hover:bg-[#b8031f]" data-testid="rules-back-portal">← Retour à mon espace membre</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-7">
      <h2 className="text-lg font-bold text-[#C9A961] mb-1.5">{title}</h2>
      <p className="text-white/70 leading-relaxed">{children}</p>
    </div>
  );
}
